import { singletonMap } from '../SingletonMap/SingletonMap.js';

const sagasMap = singletonMap('sagas');
let listener;
const SagaRegistry = {
    register (name, saga) {
        if (name in sagasMap) {
            console.warn(`Saga with name '${name}' is already registered`);
            return;
        }
        sagasMap[name] = saga;
        if (listener) {
            listener(saga);
        }
    },
    set listener (l){
        listener = l;
    },
    get sagas () {
        return Object.values(sagasMap);
    }
};

export { SagaRegistry };
//# sourceMappingURL=SagaRegistry.js.map
